import { render } from "./ContactVue.vue?vue&type=template&id=d6979c04&scoped=true"
const script = {}

import "../assets/css/contact.css?vue&type=style&index=0&id=d6979c04&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6979c04"]])

export default __exports__